import { AxiosRequestConfig } from 'axios';

export const isBackendRequest = ({ baseURL, url }: Pick<AxiosRequestConfig, 'baseURL' | 'url'>) => {
  if (!baseURL || !url) {
    return false;
  }

  try {
    const baseUrl = new URL(baseURL, window.location.origin);
    const requestUrl = new URL(url, baseUrl);

    return requestUrl.origin === baseUrl.origin;
  } catch (error) {
    return false;
  }
};
